import { TemplateItem } from './TemplateItem';

export class TemplateWorksheet {
  constructor(public order: number = 1, public name: string = '', public templateItems: TemplateItem[] = []) {}
}
